import React from "react";
import Header from "../../../../ui-components/LandingPage/PricingUi/Header";
// import Card from "../../../../ui-components/LandingPage/PricingUi/Card";
import PricingCard from "../../../../ui-components/LandingPage/PricingUi/PricingCard";
import CustomPlans from "../../../../ui-components/LandingPage/PricingUi/CustomPlans";
import TestimonialCards from "../../../../ui-components/LandingPage/PricingUi/TestimonialCards";

const Pricing = () => {
  return (
    <>
      {/* <div className="min-[2000px]:px-36"> */}
        <Header />
        {/* <Card /> */}
        <PricingCard />
        <CustomPlans />
        <TestimonialCards />
      {/* </div> */}
    </>
  );
};

export default Pricing;